type ITeamLike = { id?: number };
type IRoleWithTeams = { teams?: ITeamLike[] };

type IAssignableUser = {
  teams?: ITeamLike[];
  teamIds?: number[];
  roles?: IRoleWithTeams[];
};

const getAssignedTeamsCount = (user: object): number => {
  const assignableUser = user as IAssignableUser;

  if (Array.isArray(assignableUser?.teams)) {
    return assignableUser.teams.length;
  }

  if (Array.isArray(assignableUser?.teamIds)) {
    return assignableUser.teamIds.length;
  }

  if (Array.isArray(assignableUser?.roles)) {
    const roleTeamIds = assignableUser.roles.reduce<number[]>((acc, role) => {
      (role?.teams || []).forEach(team => {
        if (team?.id) {
          acc.push(team.id);
        }
      });

      return acc;
    }, []);

    return new Set(roleTeamIds).size;
  }

  return 0;
};

export default getAssignedTeamsCount;
